import IAppCardAppData from '@orcha/types/app-card-app-data';
import { useSiteContext } from 'src/store';
import { AssureAppCard, ExposeAppCard } from '@orcha/micro-library-core-ui';
import AppCardWrapper from './AppCardWrapper';

export type AppCardProps = {
  appData: IAppCardAppData;
  hideImages?: boolean;
};

export const appCardSelector = {
  expose: ExposeAppCard,
  assure: AssureAppCard,
};

const AppCard = (props: AppCardProps) => {
  const { appCardConfig } = useSiteContext();
  const AppCardComponent =
    appCardSelector[
      appCardConfig?.appCardType?.toLocaleLowerCase() ?? 'expose'
    ];

  return AppCardComponent ? (
    <AppCardWrapper {...props} AppCardComponent={AppCardComponent} />
  ) : (
    <></>
  );
};

export default AppCard;
